var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPool({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.439,
    cy: 10.508,
    r: 2.205,
    fill: "#010065"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M7.44 8.464c1.1 0 1.732.729 1.868.878A2.21 2.21 0 0 0 5.57 9.32l.1-.102c.268-.272.808-.755 1.77-.755zm.033 2.512c.71 0 1.343.336 1.748.857a2.21 2.21 0 0 1-3.529.043c.403-.546 1.05-.9 1.78-.9z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.419,
    cy: 9.795,
    fill: "#FFF",
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.406,
    cy: 10.423,
    r: 2.205,
    fill: "#301E77"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.594,
    cy: 10.423,
    r: 2.205,
    fill: "#00007A"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.594,
    cy: 9.774,
    fill: "#FFF",
    rx: 1.053,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.406,
    cy: 9.774,
    fill: "#FFF",
    rx: 1.053,
    ry: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EB0803",
    d: "M5.142 5.16a2.298 2.298 0 0 1 2.267 2.673h.03c-1.14 0-2.087.83-2.267 1.92l-.063.001a2.295 2.295 0 0 0-2.234-1.921A2.298 2.298 0 0 1 5.141 5.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FDC101",
    d: "M9.843 5.2a2.298 2.298 0 0 1 2.267 2.673h.03c-1.14 0-2.087.83-2.266 1.92l-.063.002a2.295 2.295 0 0 0-2.234-1.922A2.298 2.298 0 0 1 9.843 5.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M9.843 7.822c.695 0 .885.396.885.536a2.296 2.296 0 0 0-.854 1.436H9.81a2.291 2.291 0 0 0-.808-1.4c0-.144.145-.572.84-.572z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FD9400",
    d: "M7.457 1.823a2.298 2.298 0 0 1 2.267 2.674l.03-.001c-1.14 0-2.087.619-2.267 1.709h-.063c-.176-1.08-1.107-1.694-2.234-1.709a2.298 2.298 0 0 1 2.266-2.673z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.843,
    cy: 6.595,
    fill: "#FFF",
    rx: 1.053,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.142,
    cy: 6.595,
    fill: "#FFF",
    rx: 1.053,
    ry: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M7.478 4.382c.695 0 .885.397.885.536a2.296 2.296 0 0 0-.855 1.436l-.063.001a2.291 2.291 0 0 0-.808-1.4c0-.145.145-.573.84-.573z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.457,
    cy: 3.155,
    fill: "#FFF",
    rx: 1.053,
    ry: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPool);
export default __webpack_public_path__ + "static/media/pool.1817228809e7300b34fa3e20008be8cc.svg";
export { ForwardRef as ReactComponent };